// CopyableInfoQuestionsModal.js
import React, { useRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Row, Col } from "reactstrap";

const CopyableInfoQuestionsModal = ({ isOpen, toggle, infoQuestionSet, infoQuestionSetEntries }) => {

  const tableRef = useRef(null); // ✨ create a ref

  const handleCopyTable = () => {
    if (tableRef.current) {
      const range = document.createRange();
      range.selectNode(tableRef.current);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        document.execCommand('copy');
        alert('已複製表格到剪貼簿！');
      } catch (err) {
        console.error('複製失敗:', err);
        alert('複製失敗');
      }

      // Clean up selection
      selection.removeAllRanges();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>
        複製表格（可直接貼到 Excel）
      </ModalHeader>

      <ModalBody>
        <div style={{ overflowX: "auto" }}>
          <Row style={{ marginBottom: "1rem" }}>
            <Col>
              <p style={{ fontSize: "15px" }}>題組名稱： {infoQuestionSet?.label}</p>
            </Col>
            <Col style={{ display:"flex", justifyContent:"flex-end" }}>
              <Button color="outline-info" onClick={handleCopyTable}>
                複製表格
              </Button>
            </Col>
          </Row>

          <div ref={tableRef}>
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>前提</th>
                  <th>問題內容</th>
                  <th>影響屬性</th>
                  <th>檢查條件</th>
                </tr>
              </thead>
              <tbody>
                {infoQuestionSetEntries.map((q, index) => (
                  <tr key={q._id}>
                    <td>{index + 1}</td>
                    <td>
                      {q.dependencies?.activationConditionSets?.map((set, j) => (
                        <React.Fragment key={j}>
                          {set.conditions.map((c, k) => (
                            <React.Fragment key={k}>
                              {c}<br />
                            </React.Fragment>
                          ))}
                          {j !== q.dependencies.activationConditionSets.length - 1 && (
                            <React.Fragment>---<br /></React.Fragment>
                          )}
                        </React.Fragment>
                      ))}
                    </td>
                    <td>{q.label}</td>
                    <td>
                      {q.dependencies?.affectedAttributes?.map((attr, j) => (
                        <div key={j}>{attr}</div>
                      ))}
                    </td>
                    <td>
                      {q.verifyRuleAI?.map((set, j) => (
                        <React.Fragment key={j}>
                          {set.conditions.map((c, k) => (
                            <React.Fragment key={k}>
                              {c}<br />
                            </React.Fragment>
                          ))}
                          {j !== q.verifyRuleAI.length - 1 && (
                            <React.Fragment>---<br /></React.Fragment>
                          )}
                        </React.Fragment>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          關閉
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CopyableInfoQuestionsModal;
